import { z } from 'zod';

// Wire shape only, so it stays browser-safe; the server-side codec is `cursorQueryInputSchema`.
export const cursor = {
    input: z.object({ cursor: z.string().optional() }),
    output: z.object({ nextCursor: z.string().nullable() }),
};
